import { useEffect, useState } from "react";
import style from "./Picker.module.scss";
import { DayButton } from "../DayButton/DayButton";

export function Picker({
    currentDate,
    onChangeDate,
}: {
    currentDate: string,
    onChangeDate: (newDate: string) => void,
}) {
    const [pickerDate, setPickerDate] = useState({
        year: 0,
        month: 0,
    });

    const [dates, setDates] = useState<JSX.Element[]>([]);

    function displayDates() {
        const datesGenerate = [];

        const lastOfPrevMonth = new Date(pickerDate.year, pickerDate.month, -1);
        for (let i = 0; i <= lastOfPrevMonth.getDay(); i++) {
            const button = <div key={i + "last"} />;
            datesGenerate.push(button);
        }

        const lastOfMOnth = new Date(pickerDate.year, pickerDate.month + 1, 0);
        for (let i = 1; i <= lastOfMOnth.getDate(); i++) {
            const day = `${String(i).padStart(2, "0")}.${String(pickerDate.month + 1).padStart(2, "0")}.${pickerDate.year}`

            datesGenerate.push(
                <DayButton
                    key={i}
                    text={i}
                    pickerDate={pickerDate}
                    isSelected={currentDate === day}
                    onClick={() => {
                        displayDates();
                        onChangeDate(day);
                    }}
                />,
            );
        }

        const firstOfNextMonth = new Date(pickerDate.year, pickerDate.month + 1, 1);
        for (let i = firstOfNextMonth.getDay(); i < 7; i++) {
            const button = <div key={i + "next"} />;
            datesGenerate.push(button);
        }

        setDates(datesGenerate);
    };

    useEffect(() => {
        displayDates()
    }, [pickerDate])

    useEffect(() => {
        setPickerDate({
            month: Number(currentDate.split(".")[1]) - 1,
            year: Number(currentDate.split(".")[2])
        })
    }, [currentDate])

    return (
        <div>
            <div className={style["datepicker-header"]}>
                <button
                    className={style["prev"]}
                    onClick={() => {
                        setPickerDate((state) => ({
                            month: (state.month - 1 + 12) % 12,
                            year: state.month === 0 ? state.year - 1 : state.year,
                        }));
                    }}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="7"
                        height="11"
                        viewBox="0 0 7 11"
                        fill="none"
                    >
                        <path
                            d="M6.18311 1.38691L2.35811 5.21191L6.18311 9.03691L4.99977 10.2119L-0.000227928 5.21191L4.99977 0.211914L6.18311 1.38691Z"
                            fill="#B5BEC6"
                        />
                    </svg>
                </button>

                <div className="flex items-center gap-[5px]">
                    <div className={style["month-input"]}>
                        {
                            [
                                "Січень",
                                "Лютий",
                                "Березень",
                                "Квітень",
                                "Травень",
                                "Червень",
                                "Липень",
                                "Серпень",
                                "Вересень",
                                "Жовтень",
                                "Листопад",
                                "Грудень",
                            ][pickerDate.month]
                        }
                    </div>
                    <p className={style["year-input"]}>{pickerDate.year}</p>
                </div>

                <button
                    className={style["next"]}
                    onClick={() => {
                        setPickerDate((state) => ({
                            month: (state.month + 1) % 12,
                            year: state.month === 11 ? state.year + 1 : state.year,
                        }));
                    }}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="17"
                        viewBox="0 0 16 17"
                        fill="none"
                    >
                        <path
                            d="M5 12.0369L8.825 8.21191L5 4.38691L6.18333 3.21191L11.1833 8.21191L6.18333 13.2119L5 12.0369Z"
                            fill="#B5BEC6"
                        />
                    </svg>
                </button>
            </div>

            <div className={style["days"]}>
                <span>Пн</span>
                <span>Вт</span>
                <span>Ср</span>
                <span>Чт</span>
                <span>Пт</span>
                <span>Сб</span>
                <span>Нд</span>
            </div>

            <div className={style["dates"]}>{dates}</div>
        </div>
    )
}

